export const GALLERY = 'gallery'
export const LIST = 'list'
export const EDIT = 'edit'

export const MODES = [GALLERY, LIST]
